/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-danger */
import React from 'react';
import ReactDOM from 'react-dom';
var Overlay = function Overlay(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose;
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "grayOverlay"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cg__overlay"
  }, /*#__PURE__*/React.createElement("button", {
    className: "cg__overlay__close",
    type: "button",
    onClick: function onClick(evt) {
      evt.preventDefault();
      onClose();
    }
  }), children)), document.body);
};
export default Overlay;